export default __webpack_public_path__ + "static/media/todo-homepage.414977bf.png";